import React from 'react';
import { Card, Col, Row, Tab, Nav, Form } from 'react-bootstrap';
import SimpleBar from 'simplebar-react';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';

const data = [
  { num: 1, emetteur: 'Mahdi', etat: 'En attente de validation' },
  { num: 2, emetteur: 'Sarah', etat: 'Validées' },
  { num: 3, emetteur: 'Ahmed', etat: 'Rejetés' },
  { num: 4, emetteur: 'Leila', etat: 'En attente de validation' },
  { num: 5, emetteur: 'Omar', etat: 'Validées' },
  { num: 6, emetteur: 'Yasmine', etat: 'Rejetés' },
  { num: 7, emetteur: 'Karim', etat: 'En attente de validation' },
  { num: 8, emetteur: 'Nadia', etat: 'Validées' },
  { num: 9, emetteur: 'Youssef', etat: 'Rejetés' },
];

const columns = [
//   {
//     accessorKey: 'date',
//     header: 'Date',
//     accessorFn: row => {
//       return new Intl.DateTimeFormat('fr-FR', {
//         day: '2-digit',
//         month: '2-digit',
//         year: 'numeric',
//       }).format(new Date(row.date));
//     },
//     meta: {
//       headerProps: { className: 'white-space-nowrap text-900 ps-0' },
//       cellProps: { className: 'font-sans-serif white-space-nowrap fs-10 ps-0' },
//     },
//   },
  {
    accessorKey: 'num',
    header: 'Numéro facture',
    meta: {
      headerProps: { className: 'white-space-nowrap text-900' },
      cellProps: { className: 'font-sans-serif white-space-nowrap fs-10' },
    },
  },
  {
    accessorKey: 'emetteur',
    header: 'Client',
    meta: {
      headerProps: { className: 'text-start text-900 ' },
      cellProps: {
        className: 'ps-2 text-start w-5 text-primary fw-semibold fs-10',
      },
    },
  },
  {
    accessorKey: 'etat',
    header: 'Magasin',
    meta: {
      headerProps: { className: 'text-end text-900 w-2' },
      cellProps: { className: 'ps-2 text-end w-5 fs-10' },
    },
  },
];

const TabTitle = ({ title, value, percentage, progress }) => (
  <div className="p-2 pe-4 text-start cursor-pointer">
    <h6 className="text-800 fs-11 text-nowrap">{title}</h6>
    <h5 className="text-800">{value}</h5>
    {/* <Flex alignItems="center">
      <FontAwesomeIcon
        icon={progress ? 'caret-up' : 'caret-down'}
        className={progress ? 'text-success' : 'text-warning'}
      />
      <h6 className={`fs-11 mb-0 ms-2 ${progress ? 'text-success' : 'text-warning'}`}>
        {percentage}
      </h6> 
    </Flex>*/}
  </div>
);
const Traites = () => {
  const table = useAdvanceTable({
    data: data,
    columns: columns,
    selection: true,
    sortable: true,
    pagination: true,
    perPage: 8,
    selectionColumnWidth: 52,
  });

  return (
    <Card className={'overflow-hidden'}>
      <Tab.Container id="audience-tab" defaultActiveKey="users">
        <SimpleBar>
          <Card.Header className="p-0 bg-body-tertiary">
            <Nav className="nav-tabs border-0 flex-nowrap chart-tab">
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="users">
                  <TabTitle
                    title="En attente de validation"
                    value="3.9K"
                    progress={true}
                    percentage="62.0%"
                  />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="sessions">
                  <TabTitle title="Validées" value="6.3K" progress={true} percentage="46.2%" />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="bounceRate">
                  <TabTitle title="Rejetés" value="9.49%" progress={false} percentage="56.1%" />
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
        </SimpleBar>

        <Card.Body>
          <Tab.Content>
            {/* <Tab.Pane unmountOnExit eventKey="users">
              <AudienceChart data={chartData.users} />
            </Tab.Pane>
            <Tab.Pane unmountOnExit eventKey="sessions">
              <AudienceChart data={chartData.sessions} />
            </Tab.Pane>
            <Tab.Pane unmountOnExit eventKey="bounceRate">
              <AudienceChart data={chartData.rate} />
            </Tab.Pane>
            <Tab.Pane unmountOnExit eventKey="sessionDuration">
              <AudienceChart data={chartData.duration} />
            </Tab.Pane> */}

            <AdvanceTableProvider {...table}>
              <AdvanceTable />
              <AdvanceTableFooter rowInfo navButtons />
            </AdvanceTableProvider>
          </Tab.Content>
        </Card.Body>
      </Tab.Container>

      <Card.Footer className="bg-body-tertiary py-2">
        {/* <Row className="g-0 flex-between-center">
          <Col xs="auto">
            <Form.Select size="sm" className="me-2">
              <option>Last 7 days</option>
              <option>Last Month</option>
              <option>Last Year</option>
            </Form.Select>
          </Col>
          <Col xs="auto">
            {/* <FalconLink title="Visitors overview" className="px-0 fw-medium" /> 
          </Col>
        </Row> */}
      </Card.Footer>
    </Card>
  );
};
export default Traites;
